// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080605/js/" + chunkId + "." + {"44":"9f3f12ba","225":"e75b17f0","481":"9e31847b","486":"0cf8d6c3","770":"769fec86"}[chunkId] + ".0.29868363243420404.chunk.js";
};